export const ANASAYFA = '/';
export const TUM_SIPARISLER = '/tum-siparisler';
export const MUSTERILER = '/musteriler';
export const MUSTERILER_REDIRECTED = '/musteriler/redirected';
export const SIPARIS_DETAY = '/siparis-detay';
export const MUSTERI_PROFIL = '/musteri-profil';
export const MUSTERI_PROFIL_TEL = '/musteri-profil/telefon';
export const GIRIS = '/giris';
